import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { constants } from "@lib/constants";

// Initial state
const initialState = {
  allInstitutions: [],
  allInstitutionsLoading: false,
  institutionDetails: null,
  institutionLoading: false,
  error: null,
};

// 🔹 Fetch all institutions
export const fetchInstitutions = createAsyncThunk(
  "institutionReducer/fetchInstitutions",
  async ({ axiosGet }, thunkAPI) => {
    try {
      const response = await axiosGet(`${constants.LIST_INSTITUTIONS}`);
      return response.institutions;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// 🔹 Fetch single institution
export const fetchInstitutionDetails = createAsyncThunk(
  "institutionReducer/fetchInstitutionDetails",
  async ({ axiosGet, id }, thunkAPI) => {
    try {
      const response = await axiosGet(`${constants.GET_INSTITUTION}/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const institutionReducer = createSlice({
  name: "institutionReducer",
  initialState,
  reducers: {
    clearInstitutionDetails: (state) => {
      state.institutionDetails = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInstitutions.pending, (state) => {
        state.allInstitutionsLoading = true;
        state.error = null;
      })
      .addCase(fetchInstitutions.fulfilled, (state, action) => {
        state.allInstitutions = action.payload;
        state.allInstitutionsLoading = false;
      })
      .addCase(fetchInstitutions.rejected, (state, action) => {
        state.allInstitutionsLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchInstitutionDetails.pending, (state) => {
        state.institutionLoading = true;
        state.error = null;
      })
      .addCase(fetchInstitutionDetails.fulfilled, (state, action) => {
        state.institutionDetails = action.payload;
        state.institutionLoading = false;
      })
      .addCase(fetchInstitutionDetails.rejected, (state, action) => {
        state.institutionLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearInstitutionDetails } = institutionReducer.actions;
export default institutionReducer.reducer;
